import React, { Component } from 'react';

import { Modal, Row, Col } from 'antd';

import ContentHolder from '../../UI/ContentHolder';
import Card from './card.style';

class AddProductModal extends Component {
  render() {
    const rowStyle = {
      width: '100%',
      display: 'flex',
      flexFlow: 'row wrap',
    };
    const colStyle = {
      marginBottom: '16px',
    };
    const gutter = 16;
    return (
      <Modal
        width="90%"
        visible={this.props.open}
        title="Product toevoegen"
        onCancel={this.props.onClose}
        footer={null}
      >
        <div>
          <Row style={rowStyle} gutter={gutter} justify="start">
            <Col md={6} sm={12} xs={24} style={colStyle}>
                <ContentHolder>
                  <Card
                    onClick={() => this.props.onConfirm({
                      name: 'Mix van gegrilde groenten',
                      category: 'Greens gegrilde groenten',
                    })}
                    bodyStyle={{ cursor: 'pointer', padding: 0 }}
                  >
                    <div className="custom-image">
                      <img
                        alt="example"
                        width="100%"
                        src="http://www.darta.com/thumb/public/uploads/images/products/5041.jpg&resize=true&pos=right&w=500&h=277"
                      />
                    </div>
                    <div className="custom-card">
                      <h3>
                        Mix van gegrilde groenten
                      </h3>
                      <p>Greens gegrilde groenten</p>
                    </div>
                  </Card>
                </ContentHolder>
            </Col>
            <Col md={6} sm={12} xs={24} style={colStyle}>
                <ContentHolder>
                  <Card
                    onClick={() => this.props.onConfirm({
                      name: 'Aubergines gegrild',
                      category: 'Greens gegrilde groenten',
                    })}
                    bodyStyle={{ cursor: 'pointer', padding: 0 }}
                  >
                    <div className="custom-image">
                      <img
                        alt="example"
                        width="100%"
                        src="http://www.darta.com/thumb/public/uploads/images/products/5011.jpg&resize=true&pos=right&w=500&h=277"
                      />
                    </div>
                    <div className="custom-card">
                      <h3>
                        Aubergines gegrild
                      </h3>
                      <p>Greens gegrilde groenten</p>
                    </div>
                  </Card>
                </ContentHolder>
            </Col>
            <Col md={6} sm={12} xs={24} style={colStyle}>
                <ContentHolder>
                  <Card
                    onClick={() => this.props.onConfirm({
                      name: 'Bonen zeer fijn voorgekookt',
                      category: 'Greens gekookte groenten',
                    })}
                    bodyStyle={{ cursor: 'pointer', padding: 0 }}
                  >
                    <div className="custom-image">
                      <img
                        alt="example"
                        width="100%"
                        src="http://www.darta.com/thumb/public/uploads/images/products/0855.jpg&resize=true&pos=right&w=500&h=277"
                      />
                    </div>
                    <div className="custom-card">
                      <h3>
                        Bonen zeer fijn voorgekookt
                      </h3>
                      <p>Greens gekookte groenten</p>
                    </div>
                  </Card>
                </ContentHolder>
            </Col>
            <Col md={6} sm={12} xs={24} style={colStyle}>
                <ContentHolder>
                  <Card
                    onClick={() => this.props.onConfirm({
                      name: 'Babymaïs',
                      category: 'Greens monoproducten',
                    })}
                    bodyStyle={{ cursor: 'pointer', padding: 0 }}
                  >
                    <div className="custom-image">
                      <img
                        alt="example"
                        width="100%"
                        src="http://www.darta.com/thumb/public/uploads/images/products/2121.jpg&resize=true&pos=right&w=500&h=277"
                      />
                    </div>
                    <div className="custom-card">
                      <h3>
                        Babymaïs
                      </h3>
                      <p>Greens monoproducten</p>
                    </div>
                  </Card>
                </ContentHolder>
            </Col>
          </Row>
          <Row style={rowStyle} gutter={gutter} justify="start">
            <Col md={6} sm={12} xs={24} style={colStyle}>
                <ContentHolder>
                  <Card
                    onClick={() => this.props.onConfirm({
                      name: 'Bonenbundeltjes met mager spek',
                      category: 'Greens oven & frituren',
                    })}
                    bodyStyle={{ cursor: 'pointer', padding: 0 }}
                  >
                    <div className="custom-image">
                      <img
                        alt="example"
                        width="100%"
                        src="http://www.darta.com/thumb/public/uploads/images/products/0841.jpg&resize=true&pos=right&w=500&h=277"
                      />
                    </div>
                    <div className="custom-card">
                      <h3>
                        Bonenbundeltjes met mager spek
                      </h3>
                      <p>Greens oven & frituren</p>
                    </div>
                  </Card>
                </ContentHolder>
            </Col>
            <Col md={6} sm={12} xs={24} style={colStyle}>
                <ContentHolder>
                  <Card
                    onClick={() => this.props.onConfirm({
                      name: 'Aardappelen met hesp en ajuin',
                      category: 'Greens ready to eat',
                    })}
                    bodyStyle={{ cursor: 'pointer', padding: 0 }}
                  >
                    <div className="custom-image">
                      <img
                        alt="example"
                        width="100%"
                        src="http://www.darta.com/thumb/public/uploads/images/products/A113.jpg&resize=true&pos=right&w=500&h=277"
                      />
                    </div>
                    <div className="custom-card">
                      <h3>
                        Aardappelen met hesp en ajuin
                      </h3>
                      <p>Greens ready to eat</p>
                    </div>
                  </Card>
                </ContentHolder>
            </Col>
            <Col md={6} sm={12} xs={24} style={colStyle}>
                <ContentHolder>
                  <Card
                    onClick={() => this.props.onConfirm({
                      name: 'Aardbeien',
                      category: 'Greens fruit',
                    })}
                    bodyStyle={{ cursor: 'pointer', padding: 0 }}
                  >
                    <div className="custom-image">
                      <img
                        alt="example"
                        width="100%"
                        src="http://www.darta.com/thumb/public/uploads/images/products/8011.jpg&resize=true&pos=right&w=500&h=277"
                      />
                    </div>
                    <div className="custom-card">
                      <h3>
                        Aardbeien
                      </h3>
                      <p>Greens fruit</p>
                    </div>
                  </Card>
                </ContentHolder>
            </Col>
            <Col md={6} sm={12} xs={24} style={colStyle}>
                <ContentHolder>
                  <Card
                    onClick={() => this.props.onConfirm({
                      name: 'Dille',
                      category: 'Greens kruiden',
                    })}
                    bodyStyle={{ cursor: 'pointer', padding: 0 }}
                  >
                    <div className="custom-image">
                      <img
                        alt="example"
                        width="100%"
                        src="http://www.darta.com/thumb/public/uploads/images/products/7031.jpg&resize=true&pos=right&w=500&h=277"
                      />
                    </div>
                    <div className="custom-card">
                      <h3>
                        Dille
                      </h3>
                      <p>Greens kruiden</p>
                    </div>
                  </Card>
                </ContentHolder>
            </Col>
          </Row>
        </div>
      </Modal>
    );
  }
}

export default AddProductModal;


// WEBPACK FOOTER //
// ./src/components/Orders/Modals/AddProductModal.js